import { CavernsSubmodeKeyType } from 'dt-common/generated/types/enums';
import { ApiErrorMessage } from 'dt-common/types/enums';
import mutationSetPortalLevelToCurrentDepth from '~/graphql/caverns/mutationSetPortalLevelToCurrentDepth';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import { logError } from '~/logger';
import messages, { CavernsStoreMessage } from '../messages';

export default async function setPortalLevelToCurrentDepth(
  {
    playerId,
    setCavernsData,
    emit,
    onMissingCavernsRunData,
  }: {
    playerId: string | null;
    setCavernsData: (val: any) => void;
    emit: (message: CavernsStoreMessage, data?: any) => void;
    onMissingCavernsRunData: () => void;
  },
  { game_submode }: { game_submode: CavernsSubmodeKeyType; }
) {
  if (!playerId) {
    throw new Error('Player ID is required');
  }

  try {
    const data = await mutationSetPortalLevelToCurrentDepth({
      playerId,
      game_submode,
    });

    if (data?.caverns_data) {
      setCavernsData(data.caverns_data);
    }

    emit(messages.CAVERNS_PORTAL_LEVEL_SET, {
      new_portal_level: data.new_portal_level,
    });
  } catch (err) {
    if (err instanceof GraphQlRequestError && err.errors.find((error) => error.message === ApiErrorMessage.NO_CURRENT_RUN_FOUND)) {
      onMissingCavernsRunData();
      return;
    }
    logError(err, {
      module: 'CavernsStore/handlers',
      func: 'setPortalLevelToCurrentDepth',
      playerId,
      game_submode,
    });
  }
}

